<template>
  <header id="header" class="fixed-top d-flex align-items-center">
    <div class="container">
      <div class="header-container d-flex align-items-center justify-content-between" style="margin:0px auto;">
        <!-- Logo -->
        <div class="logo">
          <router-link @click="closeMobileMenu" to="/">
            <img src="../assets/logo.png" alt="Logo" class="img-fluid" loading="lazy" />
          </router-link>
        </div>

        <!-- Navbar -->
        <nav id="navbar" class="navbar">
          <ul>
            <!-- Home -->
            <li>
              <router-link @click="closeMobileMenu" :to="'/'" class="nav-link scrollto"
                :class="{ active: isActive('/') }">
                Home
              </router-link>
            </li>

            <!-- About Us -->
            <li class="dropdown">
              <a href="#" :class="{ active: isActive('/Constitution') }" @click="toggleDropdown">
                <span>About Us</span> <i class="bi bi-chevron-down"></i>
              </a>
              <ul>
                
                <li>
                  <router-link @click="closeMobileMenu" to="/Constitution"
                    :class="{ active: isActive('/Constitution') }">
                    Our Constitution
                  </router-link>
                </li>

                <li><router-link @click="closeMobileMenu" to="/ExecutiveMembers">Executive Members</router-link></li>

                <li>
                  <router-link @click="closeMobileMenu" to="/Rules&Regulations"
                    :class="{ active: isActive('/Rules&Regulations') }">
                    Rules & Regulations
                  </router-link>
                </li>
                <li>
                  <router-link @click="closeMobileMenu" to="/about" :class="{ active: isActive('/about') }">
                    Who We Are
                  </router-link>
                </li>
                <li>
                  <router-link @click="closeMobileMenu" to="/President_And_Secretaries"
                    :class="{ active: isActive('/President_And_Secretaries') }">
                    President & Secretaries
                  </router-link>
                </li>

                <!-- NCCP Members -->
                <li class="dropdown">
                  <a href="#" @click="toggleDropdown">
                    <span>NCCP Members</span>
                    <i class="bi bi-chevron-right"></i>
                  </a>
                  <ul>
                    <li>
                      <router-link @click="closeMobileMenu" to="/Nccp_Honorary_Members"
                        :class="{ active: isActive('/Nccp_Honorary_Members') }">
                        NCCP Honorary Members
                      </router-link>
                    </li>
                    <li>
                      <router-link @click="closeMobileMenu" to="/Nccp_Life_Members"
                        :class="{ active: isActive('/Nccp_Life_Members') }">
                        NCCP Life Members
                      </router-link>
                    </li>
                    <li>
                      <router-link @click="closeMobileMenu" to="/Nccp_Ordinary_Members"
                        :class="{ active: isActive('/Nccp_Ordinary_Members') }">
                        NCCP Ordinary Fellow Members
                      </router-link>
                    </li>
                    <li>
                      <router-link @click="closeMobileMenu" to="/Nccp_Life_Fellow_Members"
                        :class="{ active: isActive('/Nccp_Life_Fellow_Members') }">
                        NCCP Life Fellow Members
                      </router-link>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>

            <!-- Activities -->
            <li class="dropdown">
              <a href="#" :class="{ active: isActive('/activities') }" @click="toggleDropdown">
                <span>Activities</span> <i class="bi bi-chevron-down"></i>
              </a>
              <ul>
                <li>
                  <router-link @click="closeMobileMenu" to="/nccp_education"
                    :class="{ active: isActive('/nccp_education') }">
                    Education
                  </router-link>
                </li>
                <li>
                  <router-link @click="closeMobileMenu" to="/Napcon_Nccp" :class="{ active: isActive('/Napcon_Nccp') }">
                    NAPCON
                  </router-link>
                </li>
                <li>
                  <router-link @click="closeMobileMenu" to="/conference" :class="{ active: isActive('/conference') }">
                    Conference
                  </router-link>
                </li>
              </ul>
            </li>

            <!-- Awards (Dynamic) -->
            <li class="dropdown">
              <a href="#" :class="{ active: isActive('/awards') }" @click="toggleDropdown">
                <span>Awards</span> <i class="bi bi-chevron-down"></i>
              </a>
              <ul class="scrollable-dropdown">
                <li v-for="award in awards" :key="award._id" class="px-4 py-2 hover:bg-gray-200 cursor-pointer"
                  @click="navigateToAward(award._id)">
                  {{ award.awardName }}
                </li>
              </ul>
            </li>

            <!-- Publications -->
            <li>
              <router-link @click="closeMobileMenu" to="/nccp_publications" class="nav-link scrollto"
                :class="{ active: isActive('/nccp_publications') }">
                NCCP Publications
              </router-link>
            </li>

            <!-- NAPCONS -->
            <li class="dropdown">
              <a href="#" :class="{ active: isActive('/napcon') }" @click="toggleDropdown">
                <span>NAPCONS</span> <i class="bi bi-chevron-down"></i>
              </a>
              <ul class="scrollable-dropdown">
                <li v-for="year in years" :key="year">
                  <router-link @click="closeMobileMenu" :to="{ name: 'NapconYear', params: { year } }">
                    NAPCON {{ year }}
                  </router-link>
                </li>
              </ul>
            </li>

            <!-- Contact -->
            <a @click="$emit('open-contact')" class="getstarted">Contact Us</a>
          </ul>

          <i class="bi bi-list mobile-nav-toggle" @click="toggleMobileMenu"></i>
        </nav>
      </div>
    </div>
  </header>
</template>

<script>
import axios from "axios";
import { API_BASE_URL } from '../utils/apis.js'
export default {
  name: "AppNavbar",

  data() {
    return {
      showpopup: false,
      years: [],
      awards: [],
    };
  },

  computed: {
    isActive() {
      return (path) => this.$route.path === path;
    },
  },

methods: {
  toggleDropdown(event) {
    if (document.querySelector("#navbar").classList.contains("navbar-mobile")) {
      event.preventDefault();
      const dropdown = event.currentTarget.nextElementSibling;
      dropdown.classList.toggle("dropdown-active");
    }
  },

  // 🔧 FIX: selector ab #navbar pe based hai, .navbar-mobile pe nahi —
  // kyunki class remove hone ke baad bhi #navbar element to exist karta hi hai
  resetDropdowns() {
    document.querySelectorAll("#navbar .dropdown ul.dropdown-active").forEach((ul) => {
      ul.classList.remove("dropdown-active");
    });
  },

  toggleMobileMenu() {
    const navbar = document.querySelector("#navbar");
    const isClosing = navbar.classList.contains("navbar-mobile"); // 🔧 class toggle hone se pehle check

    navbar.classList.toggle("navbar-mobile");

    // Toggle icon (menu <-> close)
    const icon = document.querySelector(".mobile-nav-toggle");
    icon.classList.toggle("bi-list");
    icon.classList.toggle("bi-x");

    // 🔧 FIX: agar menu close ho raha tha, to andar ke khule dropdowns reset karo
    if (isClosing) {
      this.resetDropdowns();
    }
  },

  closeMobileMenu() {
    const navbar = document.querySelector("#navbar");
    const icon = document.querySelector(".mobile-nav-toggle");
    if (navbar.classList.contains("navbar-mobile")) {
      this.resetDropdowns(); // 🔧 FIX: class remove karne SE PEHLE reset karo
      navbar.classList.remove("navbar-mobile");
      icon.classList.add("bi-list");
      icon.classList.remove("bi-x");
    }
  },

  async navigateToAward(awardId) {
    this.closeMobileMenu();
    await this.$router.push(`/awards/${awardId}`);
  },

  async fetchYears() {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/events`);
      const EventData = res.data;
      const allYears = EventData.map((item) => item.year);
      this.years = [...new Set(allYears)].sort((a, b) => b - a);
    } catch (error) {
      console.error("Error fetching years:", error);
    }
  },

  async fetchAwards() {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/awards`);
      this.awards = res.data;
    } catch (error) {
      console.error("Error fetching awards:", error);
    }
  },
},

  async mounted() {
    await this.fetchYears();
    await this.fetchAwards();
  },
};
</script>

<style scoped>
.navbar .active {
  color: #0d6efd;
}

.container {
  max-width: 1200px;
}

a {
  color: #0d6efd;
  text-decoration: none;
}

.icon-fix {
  position: fixed;
  top: 45%;
  left: 0px;
}

.round {
  margin: 0px 0px;
  padding: 10px;
  border-radius: 50%;
}

.bi-facebook { color: #0d6efd; }
.bi-instagram { color: red; }
.bi-twitter-x { color: gray; }
.bi-linkedin { color: rgb(11, 45, 196); }

/*--------------------------------------------------------------
# Back to top button
--------------------------------------------------------------*/
.back-to-top {
  position: fixed;
  visibility: hidden;
  opacity: 0;
  right: 15px;
  bottom: 15px;
  z-index: 996;
  background: #0d6efd;
  width: 40px;
  height: 40px;
  border-radius: 50px;
  transition: all 0.4s;
}
.back-to-top i {
  font-size: 28px;
  color: #fff;
  line-height: 0;
}
.back-to-top:hover {
  background: #00c28e;
  color: #fff;
}
.back-to-top.active {
  visibility: visible;
  opacity: 1;
}

@media screen and (max-width: 768px) {
  [data-aos-delay] {
    transition-delay: 0 !important;
  }
}

/*--------------------------------------------------------------
# Header
--------------------------------------------------------------*/
#header {
  transition: all 0.4s ease;
  z-index: 997;
  top: 15px;
}

#header .header-container {
  background: #fff;
  border-radius: 12px;
  height: 64px;
  margin-top: -15px;
  padding-left: 10px;
  box-shadow: 0 4px 25px rgba(13, 110, 253, 0.08), 0 1px 3px rgba(0, 0, 0, 0.04);
  transition: box-shadow 0.3s ease, height 0.3s ease;
}

#header .header-container:hover {
  box-shadow: 0 8px 30px rgba(13, 110, 253, 0.14), 0 2px 6px rgba(0, 0, 0, 0.06);
}

#header .logo {
  border-radius: 10px;
  height: 60px;
  width: 60px;
  padding: 3px;
  transition: transform 0.3s ease;
}

#header .logo:hover {
  transform: scale(1.05);
}

#header .logo h1 {
  font-size: 26px;
  padding: 0;
  line-height: 1;
  font-weight: 700;
}

#header .logo h1 a,
#header .logo h1 a:hover {
  color: #fff;
  text-decoration: none;
}

#header .logo img {
  height: 100%;
  width: 100%;
  object-fit: cover;
  border-radius: 8px;
}

@media (max-width: 992px) {
  #header {
    top: 10px;
  }

  #header.header-scrolled,
  #header .header-container {
    height: 52px;
    width: 95%;
    padding-left: 5px;
  }

  #header .logo {
    height: 45px;
    width: 45px;
  }

  #header .logo h1 {
    font-size: 24px;
  }
}

/*--------------------------------------------------------------
# Navigation Menu
--------------------------------------------------------------*/
.navbar {
  padding: 0;
}

.navbar ul {
  margin: 0;
  padding: 0;
  display: flex;
  list-style: none;
  align-items: center;
}

.navbar li {
  position: relative;
}

.navbar a,
.navbar a:focus {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0 10px 30px;
  color: #36343a;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  position: relative;
  transition: color 0.25s ease;
}

.navbar > ul > li > a::after {
  content: "";
  position: absolute;
  left: 30px;
  right: 0;
  bottom: 4px;
  height: 2px;
  background: #0d6efd;
  border-radius: 2px;
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.3s ease;
}

.navbar > ul > li > a:hover::after,
.navbar > ul > li > a.active::after {
  transform: scaleX(1);
}

.navbar a i,
.navbar a:focus i {
  font-size: 12px;
  line-height: 0;
  margin-left: 5px;
  transition: transform 0.25s ease;
}

.navbar .dropdown:hover > a i {
  transform: rotate(180deg);
}

.navbar a:hover,
.navbar .active,
.navbar .active:focus,
.navbar li:hover > a {
  color: #0d6efd;
}

.navbar .getstarted,
.navbar .getstarted:focus {
  background: #0d6efd;
  padding: 10px 25px;
  margin-left: 30px;
  margin-right: 15px;
  border-radius: 50px;
  color: #fff;
  box-shadow: 0 4px 14px rgba(13, 110, 253, 0.35);
  transition: transform 0.25s ease, box-shadow 0.25s ease, background 0.25s ease;
}

.navbar .getstarted:hover,
.navbar .getstarted:focus:hover {
  color: #fff;
  cursor: pointer;
  background: #0b5ed7;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(13, 110, 253, 0.45);
}

.navbar .dropdown ul {
  display: block;
  position: absolute;
  left: 14px;
  top: calc(100% + 20px);
  margin: 0;
  padding: 10px 0;
  z-index: 99;
  opacity: 0;
  visibility: hidden;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0px 10px 40px rgba(127, 137, 161, 0.25);
  transition: opacity 0.3s ease, top 0.3s ease, visibility 0.3s ease;
}

.navbar .dropdown ul li {
  min-width: 210px;
  font-size: 13px;
  text-transform: capitalize;
}

.navbar .dropdown ul a {
  padding: 10px 20px;
  text-transform: none;
  font-weight: 500;
  transition: background 0.2s ease, color 0.2s ease, padding-left 0.2s ease;
}

.navbar .dropdown ul a::after {
  display: none;
}

.navbar .dropdown ul a i {
  font-size: 12px;
}

.navbar .dropdown ul a:hover,
.navbar .dropdown ul .active:hover,
.navbar .dropdown ul li:hover > a {
  color: #0d6efd;
  background: rgba(13, 110, 253, 0.06);
  padding-left: 26px;
}

.navbar .dropdown:hover > ul {
  opacity: 1;
  top: 100%;
  visibility: visible;
}

.navbar .dropdown .dropdown ul {
  top: 0;
  left: calc(100% - 30px);
  visibility: hidden;
}

.navbar .dropdown .dropdown:hover > ul {
  opacity: 1;
  top: 0;
  left: 100%;
  visibility: visible;
}

@media (max-width: 1366px) {
  .navbar .dropdown .dropdown ul {
    left: -90%;
  }

  .navbar .dropdown .dropdown:hover > ul {
    left: -100%;
  }
}

/* Scrollable dropdown for long dynamic lists (Awards / NAPCONS) */
.scrollable-dropdown {
  max-height: 280px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #0d6efd #f1f1f1;
}

.scrollable-dropdown::-webkit-scrollbar {
  width: 6px;
}

.scrollable-dropdown::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.scrollable-dropdown::-webkit-scrollbar-thumb {
  background: #0d6efd;
  border-radius: 10px;
}

.scrollable-dropdown::-webkit-scrollbar-thumb:hover {
  background: #0b5ed7;
}

/**
* Mobile Navigation
*/
.mobile-nav-toggle {
  color: black;
  font-size: 26px;
  cursor: pointer;
  display: none;
  transition: transform 0.3s ease;
  padding-left: 10px;
}

.mobile-nav-toggle:active {
  transform: scale(0.85);
}

@media (max-width: 991px) {
  .mobile-nav-toggle {
    display: block;
  }

  .navbar ul {
    display: none;
  }
}

/* Single smooth white layer instead of two overlapping backgrounds */
.navbar-mobile {
  position: fixed;
  overflow: hidden;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: #fff;
  z-index: 999;
  opacity: 0;
  visibility: hidden;
  animation: mobileMenuFadeIn 0.3s ease forwards;
}

@keyframes mobileMenuFadeIn {
  from {
    opacity: 0;
    visibility: hidden;
  }
  to {
    opacity: 1;
    visibility: visible;
  }
}

.navbar-mobile .mobile-nav-toggle {
  position: absolute;
  top: 15px;
  right: 15px;
  font-size: 24px;
}

.navbar-mobile ul {
  display: block;
  position: absolute;
  top: 55px;
  right: 15px;
  bottom: 15px;
  left: 15px;
  padding: 10px 0;
  /* transparent — parent .navbar-mobile already provides the white background,
     so this inner ul no longer paints a second white layer causing flicker */
  background-color: transparent;
  overflow-y: auto;
  transition: 0.3s;
}

.navbar-mobile a,
.navbar-mobile a:focus {
  padding: 10px 16px;
  font-size: 14px;
  color: #36343a;
  border-radius: 8px;
  transition: background 0.2s ease, color 0.2s ease;
}

.navbar-mobile a::after {
  display: none;
}

.navbar-mobile a:hover,
.navbar-mobile .active,
.navbar-mobile li:hover > a {
  color: #0d6efd;
  background: rgba(13, 110, 253, 0.06);
}

.navbar-mobile .getstarted,
.navbar-mobile .getstarted:focus {
  margin: 12px 16px;
  font-size: 14px;
  text-align: center;
  justify-content: center;
}

.navbar-mobile .dropdown ul {
  position: static;
  display: none;
  margin: 6px 16px;
  padding: 5px 0;
  z-index: 99;
  opacity: 1;
  visibility: visible;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 0px 30px rgba(127, 137, 161, 0.25);
}

.navbar-mobile .dropdown ul li {
  min-width: unset;
}

.navbar-mobile .dropdown ul a {
  padding: 8px 16px;
  font-size: 13px;
}

.navbar-mobile .dropdown ul a i {
  font-size: 11px;
}

.navbar-mobile .dropdown ul a:hover,
.navbar-mobile .dropdown ul .active:hover,
.navbar-mobile .dropdown ul li:hover > a {
  color: #0d6efd;
}

/* Nested dropdown (NCCP Members submenu) — even smaller, slightly indented */
.navbar-mobile .dropdown .dropdown ul a {
  font-size: 12.5px;
  padding: 8px 16px 8px 24px;
}

.navbar-mobile .dropdown > .dropdown-active {
  display: block;
}

/* Mobile: scrollable dropdown height adjusted */
@media (max-width: 991px) {
  .scrollable-dropdown {
    max-height: 180px;
  }
}

/* Extra small phones */
@media (max-width: 400px) {
  .navbar-mobile a,
  .navbar-mobile a:focus {
    font-size: 13px;
  }

  .navbar-mobile .dropdown ul a {
    font-size: 12px;
  }

  .navbar-mobile .dropdown .dropdown ul a {
    font-size: 11.5px;
  }
}

.pop-up-contact {
  display: grid;
  place-content: center;
  place-items: center;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8);
}

.popup-form {
  width: 100%;
  background: rgba(0, 0, 0, 0.8);
  padding: 50px;
}

.popup-form i {
  cursor: pointer;
  position: absolute;
  right: 26%;
  margin-top: -30px;
  font-size: 20px;
  color: #0d6efd;
}

.formsubmit {
  padding: 30px;
}

.form-input {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.form-input input {
  width: 300px;
  border: none;
  border-bottom: 1px solid #0d6efd;
  background: transparent;
}

::placeholder {
  color: #fff;
}

.router-link-active.router-link-exact-active {
  color: #0d6efd;
}

.input-message {
  width: 100%;
  background: transparent;
  border: none;
  border-bottom: 1px solid #0d6efd;
}

.submit {
  text-align: center;
}

.submit input {
  padding: 3px 10px;
  width: 50%;
  background: transparent;
  color: #fff;
  border: 3px solid #0d6efd;
  border-radius: 30px;
  transition: 0.3s;
}

.submit input:hover {
  background: #0d6efd;
  color: #fff;
}

@media (max-width: 768px) {
  .form-input {
    display: grid;
    grid-template-columns: 100%;
    gap: 20px;
  }

  .popup-form i[data-v-12c3dba6] {
    cursor: pointer;
    position: absolute;
    right: 12%;
    margin-top: 25px;
    font-size: 20px;
    color: #0d6efd;
  }
}
</style>